import { Link } from "react-router-dom";
import { Box, Button, Typography } from "@mui/material";
import { SearchOff } from "@mui/icons-material";

export default function NotFound() {
  return (
    <Box sx={{ textAlign: "center", py: 10 }}>
      <SearchOff sx={{ fontSize: 64, color: "text.disabled", mb: 2 }} />
      <Typography variant="h4" gutterBottom>404</Typography>
      <Typography color="text.secondary" sx={{ mb: 3 }}>Page not found</Typography>
      <Link to="/"><Button variant="contained">Go home</Button></Link>
    </Box>
  );
}
